export default 
  {
    orderID: 1,
    ponumber: "AEAN2001",
    clientname: "Davis GAA Club",
    orderDate: "1/9/2020",
    orderReference: "REF123",
    makeuplocation:"",
    productionlocation:"",
    artwork:"",
    garmentname:"Personalised Gaelic Jersey",
    garmentimage:"DIGI48705.jpg",
    status: "Awaiting Makeup"
  }
